module.exports = __webpack_public_path__ + "media/img/skills-future-logo-499062ab56f905f5365a5330f82b9412.png";